import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../lib/cn.js";
/** docs/design.md §7.2 — 32×32 default, 44×44 minimum in Live Mode/touch/controller contexts (`NFR-A7`). */
const iconButtonVariants = cva([
    "inline-flex shrink-0 items-center justify-center rounded-md transition-colors duration-fast",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 focus-visible:ring-offset-canvas",
    "disabled:pointer-events-none disabled:opacity-40",
].join(" "), {
    variants: {
        variant: {
            ghost: "bg-transparent text-fg-secondary hover:bg-surface-hover hover:text-fg-primary",
            solid: "bg-surface-overlay text-fg-primary hover:bg-surface-hover",
            /** §7.2's "armed" toggle state (e.g. Blackout while active) — fill change + icon swap at the call site, never color alone. */
            armed: "bg-status-critical text-white hover:bg-status-critical/90",
        },
        size: {
            md: "size-8 [&_svg]:size-5",
            lg: "size-11 [&_svg]:size-5",
        },
    },
    defaultVariants: {
        variant: "ghost",
        size: "md",
    },
});
export const IconButton = React.forwardRef(({ className, variant, size, ...props }, ref) => {
    return (_jsx("button", { ref: ref, type: "button", className: cn(iconButtonVariants({ variant, size }), className), ...props }));
});
IconButton.displayName = "IconButton";
//# sourceMappingURL=icon-button.js.map